<router-outlet (window:resize)="viewService.onResize()"></router-outlet>

@if (loadingRouteConfig) {
  <div class="progress-spinner" >
    <p-progressSpinner/>
  </div>
}

<p-confirmDialog/>
